import React, {useEffect, useState, useRef} from 'react';
import CircularProgress from '@material-ui/core/CircularProgress'
import WarningModal from '../components/modal'

interface PayoutsProps{
    type:string;
    phoneNumber: string;
    amount:string;
    accNo?:string;
    ifsc?:string;
    user?:string;
    membershipID?: string;
    handleToUpdateStatus: Function;
    coupon?:string;
    prevBankUUID: Array<any>;
    coupons: Array<{ code: string; amount: string, brand?: string }>;
    pollTransactionStatusForOrder: Function;
    setMultiScanResults?: React.Dispatch<
      React.SetStateAction<
        Array<{ coupon: string; status: string; message: string; orderId?: string; razor_transaction_id?: string , amount?: string }>
      >
    >;
    getTransactions: Function;
}

export const Payouts: React.FC<PayoutsProps> = (props: PayoutsProps) => {

  const [loading, setLoading] = useState(false)
  const [locationBlocked, setLocationBlocked] = useState(false)
    const [couponResults, setCouponResults] = useState<Array<{ coupon: string; status: string; message?: string }>>([]);
    
  const{
    handleToUpdateStatus, phoneNumber, amount, type, accNo, ifsc, user, membershipID, coupon, 
    prevBankUUID, coupons,pollTransactionStatusForOrder, setMultiScanResults, getTransactions
  } = props;

  const axios = require('axios').default;

  const HOST = process.env.REACT_APP_HOST;
  const API = process.env.REACT_APP_API;
  const AZURE_HOST = process.env.REACT_APP_AZURE_HOST;
  const REACT_APP_AZURE_HOST_PAYTM_PROD = process.env.REACT_APP_AZURE_HOST_PAYTM_PROD;
  const REACT_APP_AZURE_HOST_PAYTM_UAT = process.env.REACT_APP_AZURE_HOST_PAYTM_UAT;
  const REACT_APP_AZURE_HOST_BANK_PROD = process.env.REACT_APP_AZURE_HOST_BANK_PROD;
  const REACT_APP_AZURE_HOST_BANK_UAT = process.env.REACT_APP_AZURE_HOST_BANK_UAT;

  const path = window.location.pathname;
  const pathParams = path.split('/')

  const message ='Something went wrong. Please Retry.'

  const heading = "Location Disabled !!"
  const content = "Please allow location services"


const statusCheck = async (code: any, message: string, orderId:string, razor_transaction_id?:string) => {
  
  if (code === 'DE_001') {
    handleToUpdateStatus('SUCCESS', "success", orderId, '-' );
  } 
  else if(code === 'processed' || code === 'SUCCESS') {
    handleToUpdateStatus('SUCCESS', "success", orderId, razor_transaction_id, '-' );
  }
  else if(code === 'queued' || code === 'pending' || code === 'processing' || code === 'APPROVAL_PENDING'
    || code === 'PENDING' || code === 'QUEUED' || code === 'RECEIVED'){
    handleToUpdateStatus('PENDING', message, orderId, razor_transaction_id, '-');
  }
  else if(code === 'rejected' || code === 'cancelled' || code === 'reversed' || code === 'FAILED'
    || code === 'MANUALLY_REJECTED' || code === 'REJECTED' || code === 'REVERSED'){
    handleToUpdateStatus('FAILURE', message, orderId, razor_transaction_id, '-');
  }
  else if(code === 'DE_101' || code === 'DE_102'){
    handleToUpdateStatus('PENDING', message, orderId, '-');
  }
  else{
    return  handleToUpdateStatus('FAILURE', message, orderId, '-');
  }
}

const initiateWalletTransaction = async (a:any, b:any, pincode:any, city:any) => {
  setLoading(true);

  // MULTI‑COUPON FLOW
  if (coupons && coupons.length > 0) {
      getTransactions();
    coupons.forEach((c) => {
      axios
        .post(
          `${REACT_APP_AZURE_HOST_PAYTM_PROD}`,
          {
            phoneNumber:
              localStorage.getItem("IS_LOGIN") === "yes"
                ? localStorage.getItem("phone_number")
                : phoneNumber,
            amount: c.amount,
            coupon: c.code,
            membershipId: membershipID,
            userType: user,
            user_latitude: a,
            user_longitude: b,
            user_pincode: pincode,
            user_city: city,
            product: c.brand,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response: any) => {
          const data = response.data.data;
          statusCheck(data.statusCode, data.statusMessage, response.data.orderId);
          setCouponResults(prev => [
            ...prev,
            { coupon: c.code, status: data.statusCode, message: data.statusMessage }
          ]);
          pollTransactionStatusForOrder(response.data.orderId, null, 'wallet');
        })
        .catch((err: any) => {
          const dispMess = err.response;
          if (dispMess?.status === 400) {
            if (dispMess.data?.message) {
              handleToUpdateStatus('RESPONSE_MESSAGE', dispMess.data.message, '-', '-');
            } else {
              handleToUpdateStatus('FAILURE', message, '-', '-');
            }
          } else {
            handleToUpdateStatus('BLOCKUSER', "Something went wrong please try again.", '-', '-');
          }
          setCouponResults(prev => [
            ...prev,
            { coupon: c.code, status: 'FAILURE', message: dispMess?.data?.message || 'Payout failed' }
          ]);
        })
        .finally(() => setLoading(false));
    });

    return;
  }

  // SINGLE‑COUPON FLOW 
  axios
    .post( `${REACT_APP_AZURE_HOST_PAYTM_UAT}`,{
      phoneNumber: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNumber,
      amount: amount,
      coupon: coupon,
      membershipId: membershipID,
      userType: user,
      user_latitude: a,
      user_longitude: b,
      user_pincode: pincode,
      user_city: city,
      product: pathParams[1]
    },
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }
  )
  .then((response: any) => {
    setLoading(false);
    const data = response.data.data
    statusCheck(data.statusCode, data.statusMessage, response.data.orderId)
  })
  .catch((err: any) => {
    var dispMess = err.response;
    setLoading(false);
    if(dispMess.status === 400) {
      if(dispMess.data.message) {
        handleToUpdateStatus('RESPONSE_MESSAGE', dispMess.data.message, '-', '-')
      }
      else {
        handleToUpdateStatus('FAILURE', message, '-', '-') 
      }
    }
    else {
      handleToUpdateStatus('BLOCKUSER', "Something went wrong please try again.", '-', '-') 
    }
  });
};

const initiateBankTransaction = async (a:any, b:any, pincode:any, city:any) => {
  setLoading(true);
  // MULTI‑COUPON FLOW: use coupons array when present
  if (coupons && coupons.length > 0) {
            getTransactions();
    coupons.forEach((c) => {
      axios
        .post(
          `${HOST}${API}initiate-cashfree-bank-transaction/`,
          prevBankUUID[1] === "from_old_bank"
            ? {
                phoneNumber:
                  localStorage.getItem("IS_LOGIN") === "yes"
                    ? localStorage.getItem("phone_number")
                    : phoneNumber,
                amount: c.amount,
                coupon: c.code,
                membershipId: membershipID,
                userType: user,
                user_latitude: a,
                user_longitude: b,
                user_pincode: pincode,
                user_city: city,
                product: c.brand,
                from_old_bank: prevBankUUID[1] === "from_old_bank" && true,
                bank_uuid: prevBankUUID[0],
                is_bank: true,
                beneficiaryName: "test",
              }
            : {
                phoneNumber:
                  localStorage.getItem("IS_LOGIN") === "yes"
                    ? localStorage.getItem("phone_number")
                    : phoneNumber,
                amount: c.amount,
                ifsc: ifsc,
                accountNumber: accNo,
                coupon: c.code,
                membershipId: membershipID,
                userType: user,
                user_latitude: a,
                user_longitude: b,
                user_pincode: pincode,
                user_city: city,
                product: c.brand,
                is_bank: true,
                beneficiaryName: "test",
              },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response: any) => {
          const data = response.data.data;
          statusCheck(
            data.status,
            data.status_description,
            data.transfer_id,
            data.cf_transfer_id
          );
          pollTransactionStatusForOrder(
            data.transfer_id,
            data.cf_transfer_id || null,
            'bank'
          );
          const resultItem = {
            coupon: c.code,
            status: data.status as string,
            message: data.status_description as string,
            orderId: response.data.orderId,
            razor_transaction_id: data.cf_transfer_id || null,
            amount: c.amount
          };
          setCouponResults(prev => [
            ...prev,
            resultItem,
          ]);
          if (setMultiScanResults) {
            setMultiScanResults(prev => [
              ...prev,
              resultItem,
            ]);
          }
        })
        .catch((err: any) => {
          const msg = err.response?.data?.message || 'Payout failed';
          handleToUpdateStatus('FAILURE', msg, '-', '-');
          const resultItem = {
            coupon: c.code,
            status: 'FAILURE',
            message: msg,
            orderId: '-',
            razor_transaction_id: '-',
          };
          setCouponResults(prev => [
            ...prev,
            resultItem,
          ]);
          if (setMultiScanResults) {
            setMultiScanResults(prev => [
              ...prev,
              resultItem,
            ]);
          }
        })
        .finally(() => setLoading(false));
    });

    return;
  }

  // SINGLE‑COUPON FLOW (unchanged)
  return axios
    .post( `${HOST}${API}initiate-cashfree-bank-transaction/`,
      prevBankUUID[1] === "from_old_bank" ? {
      phoneNumber: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNumber,
      amount: amount,
      coupon: coupon,
      membershipId: membershipID,
      userType: user,
      user_latitude: a,
      user_longitude: b,
      user_pincode: pincode,
      user_city: city,
      product: pathParams[1],
      from_old_bank: prevBankUUID[1] === "from_old_bank" && true,
      bank_uuid: prevBankUUID[0],
      is_bank: true,
      beneficiaryName: "test"
    } : 
    {
      phoneNumber: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNumber,
      amount: amount,
      ifsc: ifsc,
      accountNumber: accNo,
      coupon: coupon,
      membershipId: membershipID,
      userType: user,
      user_latitude: a,
      user_longitude: b,
      user_pincode: pincode,
      user_city: city,
      product: pathParams[1],
      is_bank: true,
      beneficiaryName: "test"
    },
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }
  )
  .then((response: any) => {
    setLoading(false);
    const data = response.data.data
    statusCheck(data.status, data.status_description, data.transfer_id, data.cf_transfer_id)
  })
  .catch((err: any) => {
    var dispMess = err.response;
    setLoading(false);
    if(dispMess.status === 400) {
      if(dispMess.data.message) {
        handleToUpdateStatus('RESPONSE_MESSAGE', dispMess.data.message, '-', '-')
      }
      else {
        handleToUpdateStatus('FAILURE', message, '-', '-') //HANDLE INVALID IFSC
      }
    }
    else {
      handleToUpdateStatus('BLOCKUSER', "Something went wrong please try again.", '-', '-') 
    }
  });
};


const initiatePointsTransaction = async (a:any, b:any, pincode:any, city:any) => { //change body  
  setLoading(true);
  // MULTI‑COUPON FLOW: fire all requests, but update UI as each one returns
  if (coupons && coupons.length > 0) {
    getTransactions();

    let processed = 0;
    let successCount = 0;
    let loaderStopped = false;

    const total = coupons.length;

    const stopLoaderOnce = () => {
      if (!loaderStopped) {
        loaderStopped = true;
        setLoading(false);
      }
    };

    coupons.forEach((c) => {
      axios
        .post(
          `${HOST}${API}initiate-points-transaction/`,
          {
            phoneNumber:
              localStorage.getItem("IS_LOGIN") === "yes"
                ? localStorage.getItem("phone_number")
                : phoneNumber,
            membershipId: membershipID,
            coupon: c.code,
            amount: c.amount,
            user: user,
            user_latitude: a,
            user_longitude: b,
            user_pincode: pincode,
            user_city: city,
            product: c.brand,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((resp: any) => {
          const data = resp.data.data.data[0];

          const rawCode = data.resultCode != null ? String(data.resultCode) : '';
          const desc = (data.resultDescription || '').toString();
          const lowerDesc = desc.toLowerCase();
          const orderId = resp.data.orderId;
          const hasRealOrderId = !!orderId && orderId !== '-';


          const isDuplicateMessage = lowerDesc.includes('same order with coupon is exist in the system');

          ///  - NOT a "same order with coupon..." duplicate case
          const success =
            rawCode === '0' &&
            lowerDesc.includes('success') &&
            hasRealOrderId &&
            !isDuplicateMessage;

          const resultItem = {
            coupon: c.code,
            status: success ? 'SUCCESS' : 'FAILURE',
            message: desc || (success ? 'Success' : 'Failure'),
            orderId: hasRealOrderId ? orderId : '-',
            razor_transaction_id: hasRealOrderId ? orderId : '-',
            amount: c.amount,
          };

          setCouponResults(prev => [...prev, resultItem]);
          if (setMultiScanResults) {
            setMultiScanResults(prev => [...prev, resultItem]);
          }

          processed += 1;
          if (success) {
            successCount += 1;
          }

          // Show success screen as soon as we get the first response
          if (processed === 1) {
            handleToUpdateStatus(
              success ? 'SUCCESS' : 'FAILURE',
              'Processing multiple coupons. Please check the status below.',
              '-',
              '-'
            );
          }

          // When all coupons are processed, update with final summary
          if (processed === total) {
            if (successCount === total) {
              handleToUpdateStatus('SUCCESS', 'All coupons processed successfully.', '-', '-');
            } else if (successCount === 0) {
              handleToUpdateStatus(
                'FAILURE',
                'All coupons failed. Please check the message for each coupon.',
                '-',
                '-'
              );
            } else {
              handleToUpdateStatus(
                'SUCCESS',
                `Processed ${successCount} of ${total} coupons successfully. Some coupons failed.`,
                '-',
                '-'
              );
            }
          }
        })
        .catch((err: any) => {
          const msg =
            err?.response?.data?.message ||
            (err?.response?.data?.resultDescription) ||
            'Payout failed';

          const resultItem = {
            coupon: c.code,
            status: 'FAILURE',
            message: msg,
            orderId: '-',
            razor_transaction_id: '-',
            amount: c.amount,
          };

          if (setMultiScanResults) {
            setMultiScanResults(prev => [...prev, resultItem]);
          }

          processed += 1;

          if (processed === 1) {
            handleToUpdateStatus(
              'FAILURE',
              'Processing multiple coupons. Please check the status below.',
              '-',
              '-'
            );
          }

          if (processed === total) {
            if (successCount === 0) {
              handleToUpdateStatus(
                'FAILURE',
                'All coupons failed. Please check the message for each coupon.',
                '-',
                '-'
              );
            } else {
              handleToUpdateStatus(
                'FAILURE',
                `Processed ${successCount} of ${total} coupons successfully. Some coupons failed.`,
                '-',
                '-'
              );
            }
          }
        })
        .finally(() => {
          // Stop the loader as soon as the first response (success or failure) arrives
          stopLoaderOnce();
        });
    });

    return;
  }

  // SINGLE‑COUPON FLOW (existing behavior)
   return axios
    .post( `${HOST}${API}initiate-points-transaction/`,{
      phoneNumber: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNumber,
      membershipId: membershipID,
      coupon: coupon,
      amount: amount,
      user: user,
      user_latitude: a,
      user_longitude: b,
      user_pincode: pincode,
      user_city: city,
      product: pathParams[1]
    },
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }
  )
  .then((response: any) => {
    setLoading(false);
    const data = response.data.data.data[0]
    
    if(response.data.data.data[0].resultCode === "0"){
      handleToUpdateStatus("SUCCESS", "success", response.data.orderId, '-')
    }
    else{
      handleToUpdateStatus("FAILURE", data.resultDescription, response.data.orderId, '-')
    }
  })
  .catch((err: any) => {
    var dispMess = err.response;
    setLoading(false);
    if(dispMess.status === 400) {
      if(dispMess.data.message) {
        handleToUpdateStatus('RESPONSE_MESSAGE', dispMess.data.message, '-', '-')
      }
      else {
        handleToUpdateStatus('FAILURE', message, '-', '-') 
      }
    }
    else {
      handleToUpdateStatus('BLOCKUSER', "Something went wrong please try again.", '-', '-') 
    }
  });
};

const initiatedRef = useRef(false);

useEffect( () => {
    if (initiatedRef.current) return;
    initiatedRef.current = true;
    if(type === 'wallet'){
      if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions.query({
          name: 'geolocation'
      }).then(function(result) {
          if (result.state === 'denied') {
              setLocationBlocked(true)
          }
      });
    }

      if(locationBlocked === false) {
      navigator.geolocation.getCurrentPosition((pos) => {
        var geocoder = new google.maps.Geocoder();
            var latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
            geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                        var pincode;
                        var city;
                        for (var j = 0; j < results[0].address_components.length; j++) {
                          if (results[0].address_components[j].types[0] === 'postal_code') {
                              pincode = results[0].address_components[j].long_name
                          }
                          if (results[0].address_components[j].types[0] === 'locality') {
                              city = results[0].address_components[j].long_name
                          }
                        }                      
                        initiateWalletTransaction(pos.coords.latitude, pos.coords.longitude, pincode, city);
                }
            })
      }) 
    }
      else {
        setLocationBlocked(true)
      }
    }
    else if(type === 'bank'){       
      if (navigator.permissions && navigator.permissions.query) { 
        navigator.permissions.query({
          name: 'geolocation'
      }).then(function(result) {
          if (result.state === 'denied') {
              setLocationBlocked(true)
          }
      });
    }
      if(locationBlocked === false) {
      navigator.geolocation.getCurrentPosition((pos) => {
        var geocoder = new google.maps.Geocoder();
            var latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
            geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                    var pincode;
                    var city;
                    for (var j = 0; j < results[0].address_components.length; j++) {
                      if (results[0].address_components[j].types[0] === 'postal_code') {
                          pincode = results[0].address_components[j].long_name
                      }
                      if (results[0].address_components[j].types[0] === 'locality') {
                          city = results[0].address_components[j].long_name
                      }
                    }                         
                      initiateBankTransaction(pos.coords.latitude, pos.coords.longitude, pincode, city);
                }
            })
      }) 
    }
      else {
        setLocationBlocked(true)
      }
    }
    else if(type === 'points'){
      if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions.query({
          name: 'geolocation'
      }).then(function(result) {
          if (result.state === 'denied') {
              setLocationBlocked(true)
          }
      });
    }

      if(locationBlocked === false) {
      navigator.geolocation.getCurrentPosition((pos) => {
        var geocoder = new google.maps.Geocoder();
            var latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
            geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                      var pincode;
                      var city;
                      for (var j = 0; j < results[0].address_components.length; j++) {
                        if (results[0].address_components[j].types[0] === 'postal_code') {
                            pincode = results[0].address_components[j].long_name
                        }
                        if (results[0].address_components[j].types[0] === 'locality') {
                            city = results[0].address_components[j].long_name
                        }
                      }                      
                        initiatePointsTransaction(pos.coords.latitude, pos.coords.longitude, pincode, city);
                }
            })
      }) 
    }
      else {
        setLocationBlocked(true)
      } 
    }
  }, [])

return (
  <div>
    {
        loading &&
        <div className='main-loader'>
          <CircularProgress />
        </div>
    }
    {
      locationBlocked && <WarningModal heading={heading} content={content} />
    }
    {coupons.length > 0 && couponResults.length > 0 && (
  <div style={{ marginTop: 16 }}>
    {couponResults.map((r, i) => (
      <div key={i}>
        {r.coupon}: {r.status} ({r.message})
      </div>
    ))}
  </div>
)}
  </div>
);
}

export default Payouts